"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const FormCard = ({ form }) => ((0, jsx_runtime_1.jsxs)(material_1.Paper, { elevation: 0, sx: {
        borderRadius: "12px",
        mb: 2,
        p: 1,
        overflow: "hidden",
        backgroundColor: "#fff",
    }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { position: "relative", width: "100%", height: 120, bgcolor: "#f0f0f0", borderRadius: "8px", overflow: "hidden" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { fontSize: "0.85rem", mt: 1, fontWeight: 500, children: form.title.replace(/<[^>]*>/g, "") })] }));
exports.default = FormCard;
